import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { IWarehouse } from "../../warehouses.types";
import { requestUpdateWarehouse } from "./updateWarehouse.request";

const useUpdateWarehouse = (
  options?: MutationOptions<IWarehouse, ApiServiceError<ApiError>>,
) => {
  return useMutation({
    mutationFn: requestUpdateWarehouse,
    ...options,
  });
};

export default useUpdateWarehouse;
